<template>
    <div class="dots">
        <a class="skip-main" href="#main">Skip to main content</a>
        <div class="home mt-1 px-2 container" id="main" tabindex="-1">
            <div class="row">
                <div class="col-lg-10 text-left ml-1 ml-md-2">
                    <p class="mt-3 home-subtext" >Fill in your journey details below</p>
                </div>
            </div>
            <div class="row mb-n4">
                <div class="col-lg-8 mx-auto">
                    <JourneyForm></JourneyForm>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import JourneyForm from '@/components/JourneyForm.vue'

export default {
    name: 'Home',
    components: {
        JourneyForm,
    },
}

</script>
